// The site header and footer content for the apps (Titan, My Booking): the home page's phone number, call centre hours
// and Site Footer fields (Olympic.Common SiteChromeCacheManager). The app's layout writes it into the page as
// window.siteChrome, so the header and footer render with the page - no request of their own.
export function getSiteChrome() {
    return typeof window !== 'undefined' ? window.siteChrome ?? null : null;
}

/** The content given to a component, else the page's (window.siteChrome). */
export function useSiteChrome(given) {
    return given ?? getSiteChrome();
}
